const planSubscription = {
  name: 'PLAN_SUBSCRIPTION',
  fields: {
    id: '', // subscription id
    name: '', // plan name
    sku: '', // plan code
    category: 'Plan', // Plan/[Item name]
    price: '', // Unit price.
    quantity: '', // Quantity.
    currency: 'usd'
  }
}

const EVENTS = {
  PLAN_SUBSCRIPTION: 'PLAN_SUBSCRIPTION'
}
const EventModels = {
  PLAN_SUBSCRIPTION: planSubscription
}

export default {
  EVENTS,
  EventModels
}



// WEBPACK FOOTER //
// ./src/analytics/Events/Ecommerce.js